import type {
  EducationLevelResource,
  MentorClassResource,
  PortfolioShallowStudentResource,
  ScheduleWithEducationLevelsResource,
} from "api/generated";
import type {
  SelectionEducationLevel,
  SelectionLessonGroup,
  SelectionMentorClass,
  SelectionStudent,
} from "shared/types";

export const selectionMentorClassFromDto = (
  dto: MentorClassResource,
): SelectionMentorClass => ({
  name: dto.name,
  educationYear: dto.education_year,
  educationLevels: dto.education_levels,
});

export const selectionLessonGroupFromDto = (
  dto: ScheduleWithEducationLevelsResource,
): SelectionLessonGroup => ({
  id: dto.id,
  name: dto.name,
  lessonClass: dto.lesson_class,
  subject: dto.subject,
  subjectName: dto.subject_name,
  educationYear: dto.education_year,
  educationLevels: [...dto.education_levels],
});

export const selectionEducationLevelFromDto = (
  dto: EducationLevelResource,
): SelectionEducationLevel => ({
  id: Number(dto.id),
  name: dto.name,
});

export const selectionStudentFromDto = (
  resource: PortfolioShallowStudentResource,
): SelectionStudent => ({
  id: resource.id,
  firstName: resource.first_name,
  middleName: resource.middle_name,
  lastName: resource.last_name,
  studentNumber: resource.student_number,
  formattedName: resource.formatted_name,
  fullName: resource.full_name,
  mentorClass: resource.mentor_class,
  formattedEducationLevel: resource.formatted_education_level,
  profileImage: resource.profile_image ?? null,
  // Only the students-list endpoint computes these; embedded uses of the same
  // resource leave the field out.
  lessonGroupIds: resource.lesson_group_ids ?? [],
});
